import React from 'react';
import { useScrollThresholdValue } from '../../../hooks/useScrollThresholdValue';
import {
  SCROLL_ANIMATION_DURATION,
  SCROLL_ANIMATION_TRIGGER_VALUE,
} from '../../../constant/scrollValue';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { Colors } from '@banhala/ui-kit';

export const BottomDockedNudgeBannerContainer: React.FC<{
  children: React.ReactNode;
}> = props => {
  const visibilityValue = useScrollThresholdValue(
    SCROLL_ANIMATION_TRIGGER_VALUE,
    SCROLL_ANIMATION_DURATION,
  );

  const style = useAnimatedStyle(() => {
    return {
      flexDirection: 'column',
      height: visibilityValue.value * 36,
      borderBottomWidth: 1,
      borderColor: Colors.border_tertiary,
      overflow: 'hidden',
    };
  });
  return <Animated.View style={style}>{props.children}</Animated.View>;
};
